import { Fragment, type ReactNode } from 'react';

// Only http(s) URLs become links. Everything else stays plain text; React
// escapes it, and we never render user text as HTML.
const URL_PATTERN = /\bhttps?:\/\/[^\s<>"']+[^\s<>"'.,;:!?)\]]/gi;

export function linkify(text: string): ReactNode[] {
  const out: ReactNode[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_PATTERN)) {
    const start = match.index ?? 0;
    if (start > last) out.push(<Fragment key={`t${last}`}>{text.slice(last, start)}</Fragment>);
    const href = match[0];
    out.push(
      <a key={`a${start}`} href={href} target="_blank" rel="noopener noreferrer nofollow ugc">
        {href.replace(/^https?:\/\//, '')}
      </a>,
    );
    last = start + href.length;
  }
  if (last < text.length) out.push(<Fragment key={`t${last}`}>{text.slice(last)}</Fragment>);
  return out;
}
